import { FC } from 'react';

import { IcCloseIcon } from '@gem/icons';
import { FAB } from '@gem/ui-kit';

import styles from './KeywordFilterItem.styles.m.css';

interface IKeywordFilterItemProps {
  value: string;
  onDelete(): void;
}

export const KeywordFilterItem: FC<IKeywordFilterItemProps> = ({ value, onDelete }) => {
  return (
    <div className={styles.itemContainer}>
      <span className={styles.text}>{value}</span>
      <FAB
        className={styles.button}
        Icon={IcCloseIcon}
        size="10"
        theme="3_1"
        onClick={onDelete}
      />
    </div>
  );
};
